import React from 'react'
import { withWidth, withStyles } from "@material-ui/core";
import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import Alert from '@material-ui/lab/Alert';

const styles = theme => ({
    snack: {
        position: 'absolute',
        [theme.breakpoints.down("md")]: {
            position: 'fixed',
            zIndex: 1000000000000,
        },
    },
    alert: {
        alignItems: 'center',
        borderRadius: 0,

        '& .MuiAlert-message h3, & .MuiAlert-message p': {
            marginTop: 6,
            marginBottom: 6,
            width: 420,
            [theme.breakpoints.down("md")]: {
                width: '100%'
            },
        },
        '& .MuiAlert-icon': {
            padding: 13,
            background: '#f7f4f1',
            borderRadius: '50%',

            svg: {
                width: 24,
                height: 24,
            }
        },
        '&.MuiAlert-filledSuccess': {
            background: '#dfd2c5',
            borderLeft: '2px solid #b08f6e',
            color: '#b08f6e',

            '& .MuiAlert-icon': {
                backgroundImage: 'url(/images/ok.svg)',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '50%',
                backgroundPosition: '60% 50%',

                '& svg': {
                    opacity: 0
                }
            }
        },
        '&.MuiAlert-filledWarning': {
            background: '#ccced3',
            borderLeft: '2px solid #24272b',
            color: '#24272b',

            '& .MuiAlert-icon': {
                backgroundImage: 'url(/images/send.svg)',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '50%',
                backgroundPosition: '60% 50%',
                transform: 'rotate(-30deg)',

                '& svg': {
                    opacity: 0
                }
            }
        }
    }
});


const NoticeBar = ({ classes, open, onClose, title, message }) => (
    <Snackbar
        classes={{ root: classes.snack }}
        open={open ? true : false}
        onClose={() => onClose()}
        TransitionComponent={props => <Slide {...props} direction="up" />}
        autoHideDuration={10000}
    >
        <Alert classes={{ root: classes.alert }} onClose={() => onClose()} severity={open || 'info'} elevation={6} variant="filled">
            <div>
                <h3>{title}</h3>
                <p>
                    {message}
                </p>
            </div>
        </Alert>
    </Snackbar>
);


export default withWidth()(withStyles(styles, { withTheme: true })(NoticeBar));